
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SingleArticleSkeleton() {
  return (
    <div className="container mt-40">
      <Skeleton width={200} height={30} />

      <div className="d-flex mt-16 align-items-center">
        <img src="/images/calendar-start.svg" className="mr-8" alt="calendar" />
        <Skeleton width={100} height={20} />
      </div>

      <div className="white-title mt-40">
        <Skeleton count={10} />
      </div>
    </div>
  );
}

export default SingleArticleSkeleton;
